"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserPublic = exports.mockUserPrivate = exports.EventNotificationFrequencyRealTime = exports.EventNotificationFrequencyWeekly = void 0;
const affiliate_1 = require("./affiliate");
exports.EventNotificationFrequencyWeekly = 'weekly';
exports.EventNotificationFrequencyRealTime = 'real_time';
function mockUserPrivate(overrides = {}) {
    return {
        admin: false,
        affiliate: (0, affiliate_1.mockAffiliate)(),
        ambassador_code: 'AM_BASS_ADOR',
        ambassador: false,
        checkout_id: 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC82MWFmMzhlNWE2MGUyNDYwZGFkN2E3NjgwMmU5M2FjZj9rZXk9MTE2ZTJmYjg2N2YwNTA3ZGFjMzIxZWQ1MTU5ZjY4NWI=',
        created_at: '2018-09-05T00:04:33.350Z',
        display_name: 'test_user',
        email: 'user@example.com',
        experiment_group_id: 420,
        first_name: null,
        id: 12345,
        image: 'http://example.com/jpg.jpg',
        last_name: null,
        organizations: [],
        premium: false,
        premium_ordered_at: null,
        premium_expires_at: null,
        role: 'standard',
        slug: null,
        updated_at: '2018-09-05T00:04:33.350Z',
        verified: true,
        wishlist_hash: 'Jfei2na',
        zone_id: 3,
        ...overrides,
    };
}
exports.mockUserPrivate = mockUserPrivate;
function mockUserPublic(overrides = {}) {
    return {
        ambassador_code: 'AM_BASS_ADOR',
        display_name: 'test_user',
        first_name: null,
        id: 12345,
        image: 'http://example.com/jpg.jpg',
        last_name: null,
        role: 'standard',
        slug: null,
        ...overrides,
    };
}
exports.mockUserPublic = mockUserPublic;
